export default __webpack_public_path__ + "static/media/yo_5.1b63c9ce.mp3";